<template>
  <hb-section :title="$t('influencer_panel.tab_pix')" :subtitle="$t('influencer_panel.pix_destinations')">
    <template #actions>
      <b-button variant="primary" size="sm" @click="$emit('create')">
        <feather-icon icon="PlusIcon" size="14" class="mr-50" />
        {{ $t('influencer_panel.pix_register') }}
      </b-button>
    </template>

    <hb-empty-state v-if="!keys.length" :title="$t('influencer_panel.no_pix_keys')" icon="KeyIcon" />

    <div v-else>
      <div v-for="key in keys" :key="key.id" class="pix__row">
        <span class="pix__icon">
          <feather-icon :icon="iconFor(key.key_type)" size="15" />
        </span>

        <div class="pix__identity">
          <div class="pix__value">
            <code>{{ key.masked_key }}</code>
            <b-badge v-if="key.is_default" variant="light-primary">
              {{ $t('influencer_panel.default_key') }}
            </b-badge>
          </div>
          <div class="pix__type">{{ typeLabel(key.key_type) }}</div>
        </div>

        <div class="pix__status">
          <hb-status-badge :status="key.status" domain="pix" />
        </div>

        <div class="pix__actions">
          <b-button
            v-if="!key.is_default && key.status === 'VA'"
            variant="flat-primary"
            size="sm"
            @click="$emit('set-default', key)"
          >
            {{ $t('influencer_panel.pix_make_default') }}
          </b-button>
          <hb-icon-button
            icon="Trash2Icon"
            tone="danger"
            :label="$t('influencer_panel.pix_remove')"
            @click="$emit('remove', key)"
          />
        </div>
      </div>

      <p class="pix__note">
        <feather-icon icon="InfoIcon" size="13" />
        {{ $t('influencer_panel.pix_hint') }}
      </p>

      <!--
        Chave de e-mail, telefone ou aleatoria nasce pendente e nao ha, hoje, nenhum
        endpoint que a valide — na pratica so CPF/CNPJ conseguem receber saque. Dizer isso
        e melhor do que deixar o influencer descobrir na hora em que o saque falha.
      -->
      <p v-if="hasUnvalidatedKey" class="pix__warning">
        <feather-icon icon="AlertTriangleIcon" size="13" />
        {{ $t('influencer_panel.pix_pending_validation_note') }}
      </p>
    </div>
  </hb-section>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import HbSection from '@/components/hubee/HbSection.vue'
import HbStatusBadge from '@/components/hubee/HbStatusBadge.vue'
import HbEmptyState from '@/components/hubee/HbEmptyState.vue'
import HbIconButton from '@/components/hubee/HbIconButton.vue'

const TYPES = {
  CP: { label: 'CPF', icon: 'UserIcon' },
  CN: { label: 'CNPJ', icon: 'BriefcaseIcon' },
  EM: { label: 'E-mail', icon: 'MailIcon' },
  TE: { label: 'Telefone', icon: 'SmartphoneIcon' },
  AL: { label: 'Aleatória', icon: 'HashIcon' },
}

/** Chaves PIX de destino do saque. */
export default {
  name: 'PixKeysPane',
  components: {
    BBadge, BButton, HbSection, HbStatusBadge, HbEmptyState, HbIconButton,
  },
  props: {
    keys: { type: Array, default: () => [] },
  },
  computed: {
    hasUnvalidatedKey() {
      return this.keys.some(key => key.status === 'PE')
    },
  },
  methods: {
    typeLabel(type) {
      return (TYPES[type] || {}).label || type
    },
    iconFor(type) {
      return (TYPES[type] || {}).icon || 'KeyIcon'
    },
  },
}
</script>

<style scoped>
.pix__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.85rem;
  padding: 0.8rem 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

.pix__row:last-of-type {
  border-bottom: none;
}

.pix__icon {
  flex: none;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-pill);
  background: var(--tint-primary);
  color: var(--primary);
}

.pix__identity {
  flex: 1 1 200px;
  min-width: 0;
}

.pix__value {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: var(--fw-medium);
  color: var(--text-heading);
  word-break: break-all;
}

.pix__type {
  font-size: var(--fs-sm);
  color: var(--text-muted);
}

.pix__status {
  flex: 0 0 auto;
}

.pix__actions {
  flex: 0 0 auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.pix__note,
.pix__warning {
  margin: 1rem 0 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: var(--fs-xs);
  color: var(--text-muted);
}

.pix__warning {
  color: var(--warning);
}
</style>
